export function createWidgetSnapshotCoordinator() {
  let revision = 0;
  let writeQueue = Promise.resolve();

  function enqueueWrite(write) {
    const result = writeQueue.then(write);
    writeQueue = result.then(
      () => undefined,
      () => undefined,
    );
    return result;
  }

  return {
    startRequest() {
      return revision;
    },

    mutate(writeMutation) {
      revision += 1;
      return enqueueWrite(writeMutation);
    },

    async commit(requestRevision, writeSnapshot) {
      if (requestRevision !== revision) return false;

      return enqueueWrite(async () => {
        if (requestRevision !== revision) return false;

        await writeSnapshot();
        return requestRevision === revision;
      });
    },
  };
}
